export default __webpack_public_path__ + "static/media/room_3.7f6ad095.png";